function percentageDelta(currentValue, lastValue) {
  if (lastValue === 0) {
    return null;
  }
  return currentValue / lastValue - 1;
}

export default percentageDelta;
